import { render, staticRenderFns } from "./Producers.vue?vue&type=template&id=2a902e58&"
import script from "./Producers.vue?vue&type=script&lang=js&"
export * from "./Producers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports